import React from 'react';
import style from './stylesheets/Loaderstyle.module.css';

const CardLoader = () => {
    return (
        <>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        <div className={style.loderbox}></div>
        </>
        
    )
}

export default CardLoader;
